"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapsibleItemBody = exports.CollapsibleItemHeader = exports.CollapsibleItem = exports.CollapsibleSection = void 0;
const react_bootstrap_1 = require("react-bootstrap");
const styled_components_1 = __importDefault(require("styled-components"));
const config_1 = require("assets/styles/config");
exports.CollapsibleSection = (0, styled_components_1.default)(react_bootstrap_1.Accordion) `
  width: 100%;
  padding: 0;
`;
exports.CollapsibleItem = (0, styled_components_1.default)(react_bootstrap_1.Accordion.Item) `
  border: none;
  border-top: 1px solid ${config_1.colors.huron};
  border-bottom: 1px solid ${config_1.colors.huron};
  border-radius: 0 !important;
  padding: 0.5rem 1rem;
  width: 100%;
`;
exports.CollapsibleItemHeader = (0, styled_components_1.default)(react_bootstrap_1.Accordion.Header) `
  .accordion-button {
    font-weight: 400;
    font-family: ${config_1.fontFamilies.primary};
    font-size: ${config_1.fontSizes.small};
    color: ${config_1.colors.thundercloud};
    padding: 0;

    &:focus {
      box-shadow: none;
    }
  }

  .accordion-button:not(.collapsed) {
    border: none;
    background: none;
    box-shadow: none;
  }
`;
exports.CollapsibleItemBody = (0, styled_components_1.default)(react_bootstrap_1.Accordion.Body) `
  border: none;
  padding: 0.25rem 0;
`;
